import React, { FC } from "react";
import styled from "styled-components/native";
import { color, wpdColor } from "../../styles/theme";
import { StatusIndicatorInterface } from "../../../fake-data/dashboardData";

const StatusIndicatorElementOutside = styled.View`
  width: 30px;
  height: 30px;
  display: block;
  border-radius: 50%;
  background-color: ${(props: StatusIndicatorInterface) =>
    wpdColor[`${props.dataColor}Contrast` as keyof typeof wpdColor]};
  position: relative;
  margin-right: 10px;
  align-self: flex-start;
`;

const StatusIndicatorElementInsideOne = styled.View`
  width: 20px;
  height: 20px;
  display: block;
  border-radius: 50%;
  background-color: ${wpdColor.backgroundLighter};
  position: absolute;
  left: 5px;
  top: 5px;
`;

const StatusIndicatorElementInsideTwo = styled.View`
  width: 10px;
  height: 10px;
  display: block;
  border-radius: 50%;
  background-color: ${(props: StatusIndicatorInterface) =>
    wpdColor[`${props.dataColor}` as keyof typeof wpdColor]};
  position: absolute;
  left: 5px;
  top: 5px;
`;

const StatusIndicator: FC<StatusIndicatorInterface> = ({ dataColor }) => (
  <StatusIndicatorElementOutside dataColor={dataColor}>
    <StatusIndicatorElementInsideOne dataColor={dataColor}>
      <StatusIndicatorElementInsideTwo dataColor={dataColor} />
    </StatusIndicatorElementInsideOne>
  </StatusIndicatorElementOutside>
);

export default StatusIndicator;
